import { render, staticRenderFns } from "./LevelForm.vue?vue&type=template&id=4097a126&scoped=true&lang=pug&"
import script from "./LevelForm.vue?vue&type=script&lang=js&"
export * from "./LevelForm.vue?vue&type=script&lang=js&"
import style0 from "./LevelForm.vue?vue&type=style&index=0&id=4097a126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4097a126",
  null
  
)

export default component.exports